import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Button } from '@piplapps/pipl-ui';
import LoadingButton from '../../../Components/LoadingButton';

import { ProfileActions } from '../../../Redux/modules/profile/actions';
import { ProfileSelectors } from '../../../Redux/modules/profile/selectors';
import styles from './AccountActivation.module.less';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';

const RejectInvitationModal = (props) => {
  return (
    <div className={styles.modalContainer}>
      <div className={styles.header} id="modal-title">
        {gettext('Move your account to a new organization')}
      </div>

      <div className={styles.text} id="modal-body">
        {gettext(`Are you sure you want to reject the invitation?`)}
      </div>

      <div className={styles.buttonContainer}>
        <div className={styles.buttonWrapper}>
          <AnalyticsHandler eventName={AnalyticsEventNames.REJECT_INVITE}>
            <LoadingButton
              buttonClass="primary-blue"
              type="submit"
              onClick={() => props.rejectInvite(props.inviteId)}
              text={gettext('Yes')}
              id="submit-button"
            />
          </AnalyticsHandler>
        </div>
        <div className={styles.buttonWrapper} style={{ marginLeft: 20 }}>
          <Button
            buttonClass="secondary-blue"
            onClick={() => props.close()}
            text={gettext('Cancel')}
            id="cancel-button"
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    inviteId: ProfileSelectors.profileInviteIdSelector(state),
    orgAdmin: ProfileSelectors.profileInvitedBySelector(state),
    orgName: ProfileSelectors.profileInvitedByOrgNameSelector(state),
  };
};

const mapDispatchToProps = {
  rejectInvite: ProfileActions.rejectInvite,
};

RejectInvitationModal.propTypes = {
  close: PropTypes.func,
  rejectInvite: PropTypes.func,
  orgAdmin: PropTypes.string,
  orgName: PropTypes.string,
  inviteId: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(RejectInvitationModal);
